import dayjs from "dayjs";

export const isCCUserInTrial = (CcTrialStartDate?: string): boolean => {
    if (!CcTrialStartDate) {
        return false;
    }
    const today = dayjs.utc().startOf("day");
    const trialDate = dayjs.utc(CcTrialStartDate).startOf("day");
    const diffDays = Math.abs(Math.ceil(trialDate.diff(today, "days", true)));
    return diffDays < 7;
};
